import { render } from "./ViewMileageCase.vue?vue&type=template&id=beeef02e&scoped=true"
import script from "./ViewMileageCase.vue?vue&type=script&lang=js"
export * from "./ViewMileageCase.vue?vue&type=script&lang=js"

import "./ViewMileageCase.vue?vue&type=style&index=0&id=beeef02e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beeef02e"],['__file',"src/components/cases/ViewMileageCase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "beeef02e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('beeef02e', __exports__)) {
    console.log('reload')
    api.reload('beeef02e', __exports__)
  }
  
  module.hot.accept("./ViewMileageCase.vue?vue&type=template&id=beeef02e&scoped=true", () => {
    console.log('re-render')
    api.rerender('beeef02e', render)
  })

}


export default __exports__